import React from 'react';
import Select from 'react-select';
import { SelectProps } from '../../types/types';

const CustomSelect: React.FC<SelectProps> = ({
  options,
  value,
  onChange,
  placeholder,
  isMulti,
  className,
  isClearable,
  isDisabled,
  noOptionsMessage,
  menuPlacement = 'auto',
}) => {
  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isMulti={isMulti}
      className={`${className || ''}`}
      classNamePrefix="react-select"
      isClearable={isClearable}
      isDisabled={isDisabled}
      noOptionsMessage={() => noOptionsMessage || 'No options available'}
      menuPlacement={menuPlacement}
      menuPosition="fixed"
    />
  );
};

export default CustomSelect;
